module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "学员批量减课时"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "BatchCourseChangeForm",
    staticClass: "form",
    attrs: {
      "model": _vm.BatchCourseChangeParam,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID",
      "prop": "uIds"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "id以 ; 拼接"
    },
    model: {
      value: (_vm.BatchCourseChangeParam.uIds),
      callback: function($$v) {
        _vm.$set(_vm.BatchCourseChangeParam, "uIds", $$v)
      },
      expression: "BatchCourseChangeParam.uIds"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型",
      "prop": "courseType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true
    },
    model: {
      value: (_vm.BatchCourseChangeParam.courseType),
      callback: function($$v) {
        _vm.$set(_vm.BatchCourseChangeParam, "courseType", _vm._n($$v))
      },
      expression: "BatchCourseChangeParam.courseType"
    }
  }, _vm._l((_vm.courseTypeList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "减课时备注",
      "prop": "uIds"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "减课时备注必填"
    },
    model: {
      value: (_vm.BatchCourseChangeParam.memo),
      callback: function($$v) {
        _vm.$set(_vm.BatchCourseChangeParam, "memo", $$v)
      },
      expression: "BatchCourseChangeParam.memo"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingBatchCourseChange
    },
    on: {
      "click": _vm.BatchCourseChange
    }
  }, [_vm._v("确定\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56e0e9f9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/BatchCourseChangeModal.vue
// module id = 1824
// module chunks = 8